import api from "../globals/axios";

export const getProcurements = async (farmer_code, page = 1, query) => {
  let url = `biochar/procurement/?page=${page}`;
  if (query) {
    url += `&query=${query}`;
  }
  if (farmer_code) {
    url += `&farmer_code=${farmer_code}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const createProcurement = async (data) => {
  const response = await api.post("/biochar/procurement/", data);
  return response.data;
};

export const getProcurementDetail = async (id) => {
  const response = await api.get(`/biochar/procurement/${id}`);
  return response.data;
};

export const updateProcurement = async (id, data) => {
  const response = await api.patch(`/biochar/procurement/${id}/`, data);
  return response.data;
};

export const updateProcurementPickup = async (id, data) => {
  const formData = new FormData();
  for (const key in data) {
    if (Object.hasOwn(data, key)) {
      formData.append(key, data[key]);
    }
  }
  const response = await api.patch(`/biochar/procurement/${id}/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const getProcurementsForPlant = async (plant_id) => {
  let url = `biochar/procurement/?is_order_creation=true&plant_id=${plant_id}`;
  const response = await api.get(url);
  return response.data;
};

export const getPickupOrders = async (pickup_assigned_to, page = 1) => {
  let url = `biochar/pickup-order/?page=${page}`;
  if (pickup_assigned_to) {
    url = `biochar/pickup-order/?pickup_assigned_to=${pickup_assigned_to}&page=${page}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const createPickupOrder = async (data) => {
  const response = await api.post("/biochar/pickup-order/", data);
  return response.data;
};

export const getPickupOrderDetail = async (id) => {
  const response = await api.get(`/biochar/pickup-order/${id}`);
  return response.data;
};

export const updatePickupOrder = async (id, data) => {
  const response = await api.patch(`/biochar/pickup-order/${id}/`, data);
  return response.data;
};

export const getProcurementsForPickupOrder = async (pickup_order_id) => {
  let url = `biochar/procurement/?is_pickup=true&pickup_order_id=${pickup_order_id}`;
  const response = await api.get(url);
  return response.data;
};
